module.exports = __webpack_public_path__ + "img/icon-common-areas.d84e9674.svg";